import qs from 'qs';
import { queryClient } from 'App';
import useApi from 'hook/useApi';
import useApiPath from 'hook/useApiPath';
import { useQuery as useQueryOriginal } from 'react-query';

interface QueryParam {
  [key: string]: string | number | null | undefined | number[];
}

/**
 * @description
 *  GET 요청에서 쓰이는 훅입니다.
 *  ex) useQuery(요청Path, 쿼리파라미터 오브젝트)
 * @template ApiResponse
 * @param {string} path
 * @param {QueryParam} [queryParam]
 * @return {*}
 */
export default function useQuery<ApiResponse>(
  path: string,
  queryParam?: QueryParam,
) {
  const apiPath = useApiPath();
  const pathURL = `${apiPath}${path}${qs.stringify(queryParam, {
    addQueryPrefix: true,
    arrayFormat: 'repeat',
  })}`;

  const api = useApi();

  const getQuery = useQueryOriginal(
    [path, qs.stringify(queryParam)],
    async () => api.get<ApiResponse>(pathURL),
    { retry: 0 },
  );

  const resetQuery = () => queryClient.invalidateQueries([path]);

  return { getQuery, resetQuery };
}
